<template>
  <form @submit.prevent="save">
    <close-button @click="$emit('close')" class="close-button"></close-button>

    <div class="dialog-header">
      <h1>Product wijzigen</h1>
    </div>
    <div class="dialog-content">
      <div class="field-wrapper">
        <div class="field-100 label-fix">
          <label>Product</label>
          <div>
            <popup-menu class="popup" anchor-position="top">
              <span slot="trigger">
                <span class="product-type-placeholder" v-if="!productType"
                  >Kies een product</span
                >
                <span v-else class="category">{{
                  productType.name | capitalize
                }}</span>
                <button class="chevron down"></button>
              </span>
              <menu-item
                v-for="productType in printStoreStore.productTypes"
                :key="productType.id"
                @click="setProductType(productType)"
                >{{ productType.name | capitalize }}
              </menu-item>
            </popup-menu>
          </div>
        </div>
      </div>

      <div class="button-holder">
        <button
          id="confirm-button"
          class="pill-button"
          type="submit"
          :disabled="!dirty"
        >
          Wijzigen
        </button>
      </div>
    </div>
  </form>
</template>

<script>
import { mapStores } from 'pinia'
import { usePrintStoreStore } from '@/features/printstore/PrintStore.store'
import { updateProduct } from '@/features/printstore/PrintStoreApi'

export default {
  name: 'EditMultipleProductTypes',
  props: ['productIds', 'callback'],
  data() {
    return {
      productType: undefined,
      dirty: false
    }
  },
  computed: {
    ...mapStores(usePrintStoreStore)
  },
  methods: {
    setProductType(productType) {
      this.productType = productType
      this.dirty = true
    },
    save() {
      this.productIds.forEach(async (id) => {
        await updateProduct({
          id: id,
          productTypeId: this.productType.id
        })
      })
      this.callback()
      this.$emit('close')
    }
  }
}
</script>

<style scoped>
label {
  width: 51px;
}

.field-wrapper {
  margin-bottom: 20px;
}

.chevron {
  color: var(--sub-color);
  padding-left: 8px;
  vertical-align: top;
}

.popup {
  display: inline-block;
  vertical-align: text-top;
}

.product-type-placeholder {
  color: var(--sub-color);
  font-style: italic;
}

.category {
  color: #4f4f4f;
  font-weight: 500;
}
</style>
